import React, { FunctionComponent } from 'react';
import { RootState } from '../../app/store';
import { ConnectedProps, connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import {
  AppContainer,
  Main,
  MainContent,
  MainContentBody,
} from './styledComponents';
import AppHeader from './components/AppHeader/AppHeader.component';
import EventInfo from '../../components/EventInfo/EventInfo.component';
import AllEventsContainer from '../AllEvents/AllEvents.container';
import SummaryContainer from '../Summary/Summary.container';
import RightSidebar from '../../components/RightSidebar/RightSidebar.component';
import SponsorsSidebarComponent from '../../components/SponsorsSidebar/SponsorsSidebar.component';
import { useEventFeed } from '../../api/useEventFeed';
import { useQueryParams } from 'use-query-params';
import { AppQueryParamsConfigMap } from '../../app/constants';

const connector = connect((state: RootState) => ({}), {});

type PropsFromRedux = ConnectedProps<typeof connector>;

const App: FunctionComponent<PropsFromRedux> = () => {
  const [query] = useQueryParams(AppQueryParamsConfigMap);
  const { data: activeEvent } = useEventFeed({ eventId: query.e });

  return (
    <AppContainer>
      <AppHeader />
      <Main>
        <MainContent>
          <EventInfo />
          <MainContentBody>
            <Switch>
              <Route
                exact
                path="/"
                render={() => <Redirect to="/all-events" />}
              />
              <Route exact path="/all-events" component={AllEventsContainer} />
              <Route path="/feed" component={SummaryContainer} />
            </Switch>
          </MainContentBody>
        </MainContent>
        {activeEvent && (
          <>
            <RightSidebar />
            <div className="sponsors-mobile mt-20 mb-20">
              <SponsorsSidebarComponent expanded />
            </div>
          </>
        )}
      </Main>
    </AppContainer>
  );
};

export default connector(App);
